import SideMenu from '@/containers/side-menu/SideMenu.vue'
import ReportNotify from '@/pages/report-notify/ReportNotify'

export default {
  path: '/report-notify',
  name: 'NotifyReport',
  components: {
    mainContent: ReportNotify,
    mainMenu: SideMenu
  },
  meta: {
    role: {
      sectorId: 'report-notify'
    },
    breadcrumb: {
      title: 'Relatórios de Notificações',
      paths: [
        { title: 'Relatórios' },
        { title: 'Relatórios de Notificações' }
      ]
    }
  }
}